import React from 'react'

import { Carousel } from "./components/Carousel";
import { ComicServices } from "./components/ComicServices";
import { ExploreTopComics } from "./components/ExploreTopComics";
import { Mission } from "./components/Mission";


export const HomePage = () => {
	return (
		<div>
			<ExploreTopComics></ExploreTopComics>
			<Carousel></Carousel>
			<Mission></Mission>
			<ComicServices></ComicServices>
		</div>
	);
};
